import React, { useEffect, useState } from "react";
import Logo from "../../assets/logo_tag.svg";
import ModalLogo from "../../assets/logo.svg";
import "./portfolio.css";
import Automative from "../../assets/icons/automotive-portfolio.svg";
import Consumer from "../../assets/icons/consumer-products-portfolio.svg";
import Energy from "../../assets/icons/energy-portfolio.svg";
import Public from "../../assets/icons/public-sector-portfolio.svg";
import Retail from "../../assets/icons/retail-portfolio.svg";
import { motion, AnimatePresence } from "framer-motion";
import { CONSTANTS } from "../../helpers/Constant";
import Details from "./details";
import { Link } from "react-router-dom";
import Back from "../Icons/Back";

const Portfolio = () => {
  const types = [
    "Automotive",
    "Consumer Products",
    "Retail",
    "Public sector",
    "Energy",
  ];
  const [showModalLayout, setShowModalLayout] = useState(false);
  const [active, setActive] = useState(null);
  const [accessToken, setAccessToken] = useState(true);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);

  const openModalLayout = (data) => {
    setActive(data);
  };

  const closeModalLayout = () => {
    setShowModalLayout(false);
  };

  const PasswordValidation = () => {
    if (password === "") {
      setPasswordError(true);
    }
    if (password === "2mnordic") {
      setAccessToken(false);
      sessionStorage.setItem("portfolio", password);
    } else {
      setPasswordError(true);
    }
  };

  useEffect(() => {
    if (active) {
      setShowModalLayout(true);
    }
  }, [active]);

  const checkKeyDown = (e) => {
    if (e.code === "Enter") {
      e.preventDefault();
      PasswordValidation();
    }
  };

  useEffect(() => {
    if (sessionStorage.hasOwnProperty("portfolio")) {
      setAccessToken(false);
    } else {
      setAccessToken(true);
    }
  }, []);

  return (
    <>
      {accessToken ? (
        <div className="h-full flex flex-col items-center justify-center">
          <div className="w-96 bg-white rounded-lg shadow-lg relative login-view p-10">
            <img src={Logo} alt="" title="" />
            <span className="text-sm text-Gray-400 py-6 block font-avenirBook">
              You need password to view our portfolio
            </span>
            <div className="mb-3">
              <input
                type="password"
                value={password}
                className="input-field"
                placeholder="Enter password"
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError(false);
                }}
                onKeyDown={(e) => checkKeyDown(e)}
              />
              {passwordError ? (
                <span className="text-xs text-red-900">
                  Enter valid password
                </span>
              ) : null}
            </div>
            <div className="flex flex-row justify-end">
              <button
                className="brand-primary-sm-btn mt-5 transition transform"
                onClick={PasswordValidation}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-full relative portfolio-view">
          <div className="py-12">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <div className="flex flex-row items-center justify-between">
                <Link to="/">
                  <img src={Logo} alt="" />
                </Link>
                <span className="md:text-4xl text-xl opacity-10 text-Gray-900 font-avenirBook">
                  portfolio
                </span>
              </div>
            </div>
          </div>
          <div className="portfolio-intro py-10 md:w-8/12 w-full mx-auto">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <h1 className="text-blue-200 font-avenirHeavy md:text-4xl text-2xl text-center leading-snug">
                We have an extensive business knowledge{" "}
                <span className="inline md:block">
                  in many different industries
                </span>
              </h1>
              <p className="text-Gray-600 text-sm md:text-lg font-avenirBook text-center py-5">
                Explore some of our project case studies across multiple
                industries, such as
              </p>
              <div className="grid md:grid-cols-5 grid-cols-1 md:gap-6 lg:gap-6  pt-8">
                <div
                  className="bg-white rounded-lg shadow-lg border border-lightGray-200 py-8 text-center cursor-pointer hover:border-blue-200 hover:shadow-none"
                  onClick={() => openModalLayout("Automotive")}
                >
                  <img src={Automative} alt="" className="mx-auto" />
                  <span className="text-sm text-Gray-600 font-semibold pt-3 inline-block">
                    Automotive
                  </span>
                </div>
                <div
                  className="bg-white rounded-lg shadow-lg border border-lightGray-200 py-8 text-center cursor-pointer md:my-0 my-2 hover:border-blue-200 hover:shadow-none"
                  onClick={() => openModalLayout("Consumer Products")}
                >
                  <img src={Consumer} alt="" className="mx-auto" />
                  <span className="text-sm text-Gray-600 font-semibold pt-3 inline-block">
                    Consumer products
                  </span>
                </div>
                <div
                  className="bg-white rounded-lg shadow-lg border border-lightGray-200 py-8 text-center cursor-pointer md:my-0 my-2 hover:border-blue-200 hover:shadow-none"
                  onClick={() => openModalLayout("Retail")}
                >
                  <img src={Retail} alt="" className="mx-auto" />

                  <span className="text-sm text-Gray-600 font-semibold pt-3 inline-block">
                    Retail
                  </span>
                </div>
                <div
                  className="bg-white rounded-lg shadow-lg border border-lightGray-200 py-8 text-center cursor-pointer md:my-0 my-2 hover:border-blue-200 hover:shadow-none"
                  onClick={() => openModalLayout("Public sector")}
                >
                  <img src={Public} alt="" className="mx-auto" />
                  <span className="text-sm text-Gray-600 font-semibold pt-3 inline-block">
                    Public sector
                  </span>
                </div>
                <div
                  className="bg-white rounded-lg shadow-lg border border-lightGray-200 py-8 text-center cursor-pointer md:my-0 my-2 hover:border-blue-200 hover:shadow-none"
                  onClick={() => openModalLayout("Energy")}
                >
                  <img src={Energy} alt="" className="mx-auto" />
                  <span className="text-sm text-Gray-600 font-semibold pt-3 inline-block">
                    Energy
                  </span>
                </div>
              </div>
            </div>
          </div>
          <footer className="text-center text-sm font-avenirBook text-lightGray-800 py-8">
            Copyright &copy; 2021. {CONSTANTS.COMPANY_NAME} IT Consulting AB
          </footer>
        </div>
      )}
      {showModalLayout && (
        <AnimatePresence exitBeforeEnter>
          <motion.div
            className="backdrop"
            variants={CONSTANTS.MODAL_BACK_DROP}
            initial="hidden"
            animate="visible"
          >
            <motion.div
              className="w-full h-full"
              variants={CONSTANTS.MODAL_ANIMATE}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <div className=" max-w-full relative h-full">
                <div className="flex flex-row portfolio-detail h-full">
                  <div className="left-nav-menu py-8 text-right pr-14 hidden md:block">
                    <div className="flex flex-row justify-between pl-5">
                      <Back
                        className="cursor-pointer text-Gray-600"
                        onClick={closeModalLayout}
                      />
                      <img
                        src={ModalLogo}
                        alt=""
                        title=""
                        className="inline-block"
                      />
                    </div>

                    <div className="pt-24">
                      <span className="text-xs font-avenirBook text-lightGray-800 pb-10 opacity-40 block">
                        Industries
                      </span>
                      {types.map((type) => (
                        <span
                          className={`block text-lightGray-800 font-avenirRegular py-3 text-sm cursor-pointer hover:text-blue-200 ${
                            active === type ? "active" : ""
                          }`}
                          key={type}
                          active={active === type}
                          onClick={() => setActive(type)}
                        >
                          {type}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="portfolio-content">
                    <Details
                      active={active}
                      closeModalLayout={closeModalLayout}
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      )}
    </>
  );
};

export default Portfolio;
